export default __webpack_public_path__ + "static/media/cover-register-account.8912579a.jpeg";